import classNames from 'classnames';
import { Container, Row } from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';
import hasPermission from '../../Shared/hasPermission';
import DashboardTab from './DashboardTab';
import PracticeTab from './PracticeTab';
import { useLocation } from 'react-router';

const OverviewTabs = () => {
    const url = useLocation();
    
    const permissions = useSelector(
        (state) =>  state.auth.permissions,
        shallowEqual
    );

    const practiceTabsEqualityCheck = (leftState, rightState) => {
        let equality = false;
        if(leftState.length !== rightState.length) return false;
        equality = leftState.every(l => rightState.some((r) => (l.id === r.id) && (l.name === r.name)));
        return equality;
    };

    // TODO: make this its own slice of redux state
    const tabs = useSelector((state) => state.practice.selectedPracticeTabs, practiceTabsEqualityCheck);

    const canSeeDashboard = hasPermission('Dashboard', permissions);

    return (
        <Container
            className={classNames(
                `${getBackgroundStyle()} sc-rounded sc-shadow mb-4 sticky-top`,
                {
                    'd-none': !canSeeDashboard && tabs.length === 0,
                }
            )}
            style={{ top: '4rem' }}>
            <Row className="p-1 m-0 text-light">
                {canSeeDashboard && (
                        <DashboardTab url={url.pathname} />
                )}
                {tabs.map((tab, x) => (
                    <PracticeTab key={tab.id} practiceId={tab.id} url={url.pathname} practiceName={tab.name} tabIndex={x} />
                ))}
            </Row>
        </Container>
    );
};

// TODO: better way of doing this?
const getBackgroundStyle = () =>
    `flat-background-${process.env.REACT_APP_INDUSTRY}`;

export default OverviewTabs;
  